<p-messages
  [(value)]="msgs"
  [enableService]="false"
  showTransitionOptions="0ms"
></p-messages>
